import { Component, OnInit, HostListener } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { ToursService } from './Services/tours.service';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'BreakoutWebApp';
  currentYear: any;
  seasons: any[] = [];
  showSeason = false;

  constructor(private router: Router, private toursService: ToursService) {
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.getSeasons();
  }

  getSeasons() {
    this.toursService.GetSeasonlist().subscribe(seasondata => {
      if (seasondata.Response.Success && seasondata.Response.Data != null) {
        this.seasons = seasondata.Response.Data;
      }
    }, err => {
      console.log('Error fetching seasons', err);
    });
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  isQueryParamActive(path: string): boolean {
    const currentPath = this.router.url.split('?')[0];
    return currentPath === path;
  }

  gotoRoute(url: string, isHref: boolean) {
    setTimeout(() => {
      if (isHref) {
        window.open(url, "_self");
      } else {
        window.open(url, "_blank");
      }
    }, 500);
  }

  
  toggleDropdown() {
    this.showSeason = !this.showSeason;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.id !== 'tour-date-a' && target.id !== 'tour-date-li' && this.showSeason) {
      this.showSeason = false;
    }
  }

  gotoToursWithSeason(seasonId: number) {
    this.router.navigate(['/tours'], { queryParams: { seasonId: seasonId } });
  }
}
